import _toPositiveInteger from "../internals/to-positive-integer";
var exports = {};
var toPositiveInteger = _toPositiveInteger;
var $RangeError = RangeError;
exports = function (it, BYTES) {
  var offset = toPositiveInteger(it);
  if (offset % BYTES) throw new $RangeError("Wrong offset");
  return offset;
};
export default exports;